import { registerProductType } from "../api";
import photoBook from "./photo-book";
import calendar from "./calendar";

registerProductType(photoBook);
registerProductType(calendar);
